import QuestionVideoEmpty from './QuestionVideoEmpty.component';

export default QuestionVideoEmpty;